exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bandeira[data-v-aef1a328]{height:20px;width:30px}.container-accordion[data-v-aef1a328]{transition:overflow 0s;transition:all .4s;overflow-x:hidden}.container-open[data-v-aef1a328]{overflow-y:hidden;max-height:900px}.container-close[data-v-aef1a328]{transition:overflow 0s;overflow-y:hidden;max-height:50px}.accordion[data-v-aef1a328]{transition:opacity .4s linear}.open[data-v-aef1a328]{opacity:1%}.close[data-v-aef1a328]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aef1a328","scoped":true,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/forms-loja/config-bandeiras-form-loja.vue
// module id = 1935
// module chunks = 0